import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Progress } from 'reactstrap';

import allServiceGif from '../../../../assets/images/all-services.gif'
import deskVideo from '../../../../assets/resources/desk.mp4'
import congratsImg from '../../../../assets/images/congrats.jpg'
import { appendOnboarding } from '../../../../features/session/sessionSlice';
import { store } from '../../../store';

function Complete(){
    const dispatch = useDispatch()

    const state = useSelector(state => state.session.onboarding)
    const model = useSelector(state => state.site.model)

    useEffect(() => {
        setInterval(() => {
            const storeState = store.getState()
            dispatch(appendOnboarding({
                loadingStatsProgress: storeState.session.onboarding.loadingStatsProgress + 25
            }))
        }, 20000)
    }, [])

    const site = model?.sites[model?.siteActiveIdx]

    const { loadingStatsProgress } = state
    return <>
        {loadingStatsProgress >= 100 && <>
            <div class="d-flex justify-content-center align-items-center my-2">
                <h3 className="font-weight-bold">
                    Your Personalized Dashboard is Ready!
                </h3>
            </div>
            <div class="d-flex justify-content-center align-items-center my-2">
                <button className="btn btn-success btn-lg" onClick={() => window.location.href = "/"}>
                    <i class="fas fa-chart-area"></i> View Data
                </button>
            </div>
        </>}
        {loadingStatsProgress < 100 && <div class="d-flex justify-content-center align-items-center">
            <h3 className="font-weight-bold">
                Collecting up to 18 months of data... standby for a couple of minutes.
            </h3>
        </div>}
        {loadingStatsProgress >= 100 ? <img className="d-block mx-auto last-step-img" src={congratsImg} /> : 
        site?.attr?.isFranchise ? 
            <video className="d-block mx-auto last-step-img" autoPlay={true} muted={true} loop={true}>
                <source src={deskVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video> :
        <img className="d-block mx-auto last-step-img" src={allServiceGif} />}
        
        {loadingStatsProgress < 100 && <Progress
            color={"primary"}
            animated={true}
            value={loadingStatsProgress}
            className="pad-b"
            max={100}
            />}
    </>
}

export default Complete